import React, { useEffect, useState } from 'react';

const fallbackEvents = [
  {
    id: 1,
    title: 'Managing Anxiety & Stress: Interactive Workshop',
    date: '15',
    month: 'May',
    time: '10:00 AM - 12:00 PM',
    mode: 'Online (Zoom)',
    type: 'Workshop',
    speaker: 'Dr. Sarah Johnson (Clinical Psychologist)',
    price: 'Free',
    description: 'Evidence-based techniques for managing everyday stress, breathing exercises, and cognitive restructuring.',
    link: '/events'
  },
  {
    id: 2,
    title: 'Mindfulness & Emotional Resilience Masterclass',
    date: '22',
    month: 'May',
    time: '4:00 PM - 6:00 PM',
    mode: 'Online Webinar',
    type: 'Masterclass',
    speaker: 'Dr. Michael Chen (Psychiatrist)',
    price: '₹499',
    description: 'Deep dive into mindfulness techniques, emotional grounding, and building lasting resilience in daily life.',
    link: '/events'
  },
  {
    id: 3,
    title: 'Couples Communication & Relationship Wellbeing',
    date: '30',
    month: 'May',
    time: '11:00 AM - 1:00 PM',
    mode: 'Interactive Session',
    type: 'Seminar',
    speaker: 'Pooja Jagyasi & Sneha Nandanwar',
    price: 'Free',
    description: 'Practical tools and expert strategies to strengthen emotional intimacy, active listening, and conflict resolution.',
    link: '/events'
  }
];

const brandLogos = [
  'brand-1-1.png',
  'brand-1-2.png',
  'brand-1-3.png',
  'brand-1-4.png',
  'brand-1-5.png',
  'brand-1-1.png',
  'brand-1-2.png',
  'brand-1-3.png',
  'brand-1-4.png',
  'brand-1-5.png'
];

function UpcomingEventsSection() {
  const [events, setEvents] = useState(fallbackEvents);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch('/api/events');
        if (res.ok) {
          const data = await res.json();
          const list = data.events || data || [];
          if (Array.isArray(list) && list.length > 0) {
            const formatted = list.slice(0, 3).map((item, idx) => {
              const d = item.scheduledAt ? new Date(item.scheduledAt) : new Date();
              const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              return {
                id: item._id || idx,
                title: item.title || 'Mental Wellness Event',
                date: d.getDate().toString(),
                month: months[d.getMonth()],
                time: item.time || '10:00 AM - 12:00 PM',
                mode: item.mode === 'offline' ? (item.location || 'In-Person') : 'Online',
                type: item.eventType ? (item.eventType.charAt(0).toUpperCase() + item.eventType.slice(1)) : 'Workshop',
                speaker: (typeof item.createdBy === 'object' && item.createdBy?.name) ? item.createdBy.name : 'PsychMitra Expert',
                price: item.price ? (item.price === '0' || item.price === 0 ? 'Free' : `₹${item.price}`) : 'Free',
                description: item.description || 'Join our verified mental health professionals for an insightful live session.',
                link: '/events'
              };
            });
            setEvents(formatted);
          }
        }
      } catch (err) {
        // use fallbacks
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
      <section className="upcoming-events-section" style={{ padding: '90px 0 60px', backgroundColor: '#ffffff', position: 'relative' }}>
        <div className="container">
          {/* Section Header */}
          <div className="section-title text-center" style={{ marginBottom: '50px' }}>
            <span className="section-title__tagline" style={{ color: '#7c4bb9', letterSpacing: '2px', fontWeight: 600 }}>
              CONNECT &amp; LEARN
            </span>
            <h2 className="section-title__title" style={{ fontSize: '38px', marginTop: '8px' }}>
              Upcoming <span>Events</span>
            </h2>
            <p style={{ maxWidth: '640px', margin: '14px auto 0', color: '#666666', fontSize: '16px', lineHeight: '1.6' }}>
              Join interactive workshops, webinars, and masterclasses led by verified mental health professionals.
            </p>
          </div>

          {/* Events Grid */}
          <div className="row">
            {events.map((event) => (
              <div key={event.id} className="col-xl-4 col-lg-4 col-md-6 mb-4">
                <div
                  className="event-card-item"
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '24px',
                    border: '1.5px solid #ece5f8',
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 10px 30px rgba(124, 75, 185, 0.08)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
                    position: 'relative'
                  }}
                >
                  {/* Event Top Banner */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #7c4bb9 0%, #5b2d99 100%)',
                      padding: '24px 22px 20px',
                      color: '#ffffff',
                      position: 'relative'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      {/* Date Badge */}
                      <div
                        style={{
                          backgroundColor: '#ffffff',
                          color: '#5b2d99',
                          borderRadius: '14px',
                          padding: '8px 14px',
                          textAlign: 'center',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                          minWidth: '55px'
                        }}
                      >
                        <span style={{ display: 'block', fontSize: '20px', fontWeight: 800, lineHeight: 1 }}>
                          {event.date}
                        </span>
                        <span style={{ display: 'block', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginTop: '2px' }}>
                          {event.month}
                        </span>
                      </div>

                      {/* Type & Price Badges */}
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                        <span
                          style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.22)',
                            backdropFilter: 'blur(4px)',
                            color: '#ffffff',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: 600
                          }}
                        >
                          {event.type}
                        </span>
                        <span
                          style={{
                            backgroundColor: '#2ecc71',
                            color: '#ffffff',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: 700
                          }}
                        >
                          {event.price}
                        </span>
                      </div>
                    </div>

                    {/* Mode Tag */}
                    <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', opacity: 0.95 }}>
                      <i className="fas fa-video" style={{ fontSize: '12px' }}></i>
                      <span>{event.mode}</span>
                    </div>
                  </div>

                  {/* Event Content Body */}
                  <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <h3 style={{ fontSize: '19px', fontWeight: 700, color: '#2c194d', marginBottom: '10px', lineHeight: '1.4' }}>
                      <a href={event.link} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {event.title}
                      </a>
                    </h3>

                    {/* Speaker */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', color: '#7c4bb9', fontSize: '14px', fontWeight: 600 }}>
                      <i className="fas fa-user-tie"></i>
                      <span>{event.speaker}</span>
                    </div>

                    <p style={{ color: '#666666', fontSize: '14px', lineHeight: '1.6', flex: 1, margin: '0 0 20px 0' }}>
                      {event.description}
                    </p>

                    {/* Action button */}
                    <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: '1px solid #f0eaf8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ fontSize: '13px', color: '#888888' }}>
                        <i className="far fa-clock" style={{ marginRight: '6px' }}></i>
                        {event.time}
                      </div>
                      <a
                        href={event.link}
                        className="thm-btn"
                        style={{
                          padding: '8px 18px',
                          fontSize: '13px',
                          borderRadius: '20px',
                          fontWeight: 600
                        }}
                      >
                        Register
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View All Events Button */}
          <div className="text-center" style={{ marginTop: '35px' }}>
            <a
              href="/events"
              className="thm-btn"
              style={{
                padding: '12px 32px',
                fontSize: '15px',
                borderRadius: '30px',
                boxShadow: '0 8px 24px rgba(124, 75, 185, 0.22)'
              }}
            >
              Explore All Events &amp; Workshops <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
            </a>
          </div>
        </div>
      </section>

      {/* Brand Partners Carousel */}
      {/* <section className="brand-one" style={{ padding: '40px 0 60px' }}>
        <div className="container">
          <div className="brand-one__inner">
            <div
              className="thm-swiper__slider swiper-container"
              data-swiper-options='{"spaceBetween":100,"slidesPerView":5,"loop":true,"navigation":{"nextEl":"#brand-one__swiper-button-next","prevEl":"#brand-one__swiper-button-prev"},"autoplay":{"delay":5000},"breakpoints":{"0":{"spaceBetween":30,"slidesPerView":2},"375":{"spaceBetween":30,"slidesPerView":2},"575":{"spaceBetween":30,"slidesPerView":3},"767":{"spaceBetween":50,"slidesPerView":4},"991":{"spaceBetween":50,"slidesPerView":5},"1199":{"spaceBetween":100,"slidesPerView":5}}}'
            >
              <div className="swiper-wrapper">
                {brandLogos.map((logo, index) => (
                  <div className="swiper-slide" key={`${logo}-${index}`}>
                    <img src={`/assets/images/brand/${logo}`} alt="Brand Logo" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <style>{`
        .event-card-item:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(124, 75, 185, 0.18) !important;
          border-color: #7c4bb9 !important;
        }
      `}</style>
    </>
  );
}

export default UpcomingEventsSection;
